import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  grey1,
  grey5,
  grey10,
  purple7,
  blue6,
  green6,
  grey3,
  grey4,
  orange7,
} from 'approot/shared/styles/colours.style';
import {
  spacing8,
  spacing16,
  spacing24,
  spacing32,
  spacing12,
} from 'approot/shared/styles/spacing.style';
import { baseBoxShadowFocus } from 'approot/shared/styles/borders.style';
import { SmallStyled } from 'approot/shared/styles/typography.style';
import { Differentiation } from 'approot/shared/differentiation/differentiation.constants';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';
import { LAYOUT_HEADER_HEIGHT } from 'approot/shared/layout/layout.styles';
import { BoxList } from 'approot/shared/design-system/box/box.style';
import { SecondaryBaseStyled } from 'approot/shared/styles/buttons/secondary-button.style';

export const SLIDES_WIDTH = 180;

export const ActivityBuilderSlideKebab = styled.div`
  position: absolute;
  right: ${rem(spacing24)};
  top: ${rem(spacing8)};
`;

export const ActivityBuilderSlidesNav = styled.nav`
  bottom: 0;
  background-color: ${grey1};
  left: 0;
  overflow: auto;
  overflow-x: hidden;
  position: fixed;
  top: ${rem(LAYOUT_HEADER_HEIGHT)};
  padding-top: ${rem(38)};
  width: ${rem(SLIDES_WIDTH)};
`;

export const ActivityBuilderSlideItems = styled(BoxList)`
  padding: ${rem(spacing16)} 0 0 0;
`;

export const ActivityBuilderSlideIndicator = styled(SmallStyled).attrs({
  marginBottom: 0,
})`
  display: block;
  margin-right: ${rem(spacing8)};
  min-width: ${rem(18)};
  text-align: right;
`;

type ActivityBuilderSlideItemProps = {
  $isActive?: boolean;
  $differentiation?: Differentiation;
};
export const ActivityBuilderSlideItem = styled.li<ActivityBuilderSlideItemProps>`
  display: flex;
  align-items: center;
  padding: 0 ${rem(spacing16)} 0 ${rem(spacing8)};
  position: relative;

  ${({ $isActive, $differentiation }) =>
    $isActive &&
    `
      &:before {
        background-color: ${
          $differentiation === Differentiation.BlackDiamond
            ? grey10
            : $differentiation === Differentiation.BlueSquare
              ? blue6
              : $differentiation === Differentiation.GreenCircle
                ? green6
                : $differentiation === Differentiation.OrangeCross
                  ? orange7
                  : purple7
        };
        border-radius: ${rem(4)};
        content: '';
        width: ${rem(4)};
        height: ${rem(32)};
        position: absolute;
        left: 0;
      }

      ${ActivityBuilderSlideInner} {
        border-color: ${grey10};
      }
  `}

  &:hover {
    &:before {
      background-color: ${({ $differentiation }) =>
        $differentiation === Differentiation.BlackDiamond
          ? grey10
          : $differentiation === Differentiation.BlueSquare
            ? blue6
            : $differentiation === Differentiation.GreenCircle
              ? green6
              : $differentiation === Differentiation.OrangeCross
                ? orange7
                : purple7};
      border-radius: ${rem(4)};
      content: '';
      width: ${rem(4)};
      height: ${rem(32)};
      position: absolute;
      left: 0;
    }
  }
`;

export const ActivityBuilderSubSlideUl = styled(BoxList)`
  position: relative;

  &:before {
    content: '';
    background-color: ${grey4};
    border-radius: ${rem(4)};
    position: absolute;
    top: 0;
    bottom: ${rem(24)};
    left: ${rem(34)};
    width: ${rem(4)};
  }
`;

export const ActivityBuilderSlideItemSubSlide = styled(
  ActivityBuilderSlideItem
)`
  padding-left: ${rem(43)};

  ${ActivityBuilderSlideKebab} {
    top: ${rem(spacing12)};
  }
`;

export const ActivityBuilderSlideInner = styled.div`
  border-radius: ${rem(4)};
  border: 1px solid ${grey5};
  overflow: hidden;
  position: relative;
  width: ${rem(130)};
`;

export const ActivityBuilderSlide = styled.button`
  background-color: ${grey1};
  border: none;
  display: flex;
  align-items: center;
  position: relative;
  padding: 0;
  text-align: left;
  width: 100%;

  &:focus {
    outline: none;
  }

  &:hover {
    cursor: pointer;
  }

  &:focus ${ActivityBuilderSlideInner} {
    box-shadow: ${baseBoxShadowFocus};
    outline: 0;
  }

  &:focus:not(:focus-visible) ${ActivityBuilderSlideInner} {
    box-shadow: none;
  }

  &:focus-visible ${ActivityBuilderSlideInner} {
    box-shadow: ${baseBoxShadowFocus};
  }
`;

export const ActivityBuilderSubSlide = styled.button`
  background-color: ${grey1};
  border: none;
  display: flex;
  align-items: center;
  position: relative;
  padding: 0;
  text-align: left;
  width: ${rem(118)};

  &:focus {
    outline: none;
  }

  &:hover {
    cursor: pointer;
  }

  &:focus ${ActivityBuilderSlideInner} {
    box-shadow: ${baseBoxShadowFocus};
    outline: 0;
  }

  &:focus:not(:focus-visible) ${ActivityBuilderSlideInner} {
    box-shadow: none;
  }

  &:focus-visible ${ActivityBuilderSlideInner} {
    box-shadow: ${baseBoxShadowFocus};
  }
`;

export const ActivityBuilderSlideAdd = styled.button`
  ${SecondaryBaseStyled}
  ${flexCentreAlignCss}
  
  border-radius: ${rem(4)};
  height: ${rem(80)};
  width: ${rem(130)};

  svg path {
    stroke: none;
  }
`;

export const ActivityBuilderSlideDisabled = styled.div`
  ${flexCentreAlignCss}

  background-color: ${grey3};
  border-radius: ${rem(4)};
  border: 1px solid ${grey5};
  height: ${rem(80)};
  width: ${rem(130)};

  &:hover {
    cursor: not-allowed;
  }

  svg path {
    stroke: ${grey5};
  }
`;

export const ActivityBuilderAddSlideItem = styled.li`
  bottom: 0;
  padding: ${rem(spacing8)} ${rem(spacing16)} ${rem(spacing8)} ${rem(spacing32)};
  position: sticky;
`;

export const ActivityBuilderSlidePinWrapper = styled.div`
  position: absolute;
  top: ${rem(-spacing8)};
  left: ${rem(spacing16)};
  z-index: 1;
`;
